import camelcase from 'camelcase';
import { t } from '../localization';

export function getAdvisorRoleName(role) {
  const camelcasedRole = role ? camelcase(role) : null;
  const translations = t(`app:globals:roles:${camelcasedRole}`, '');
  return translations ? translations : role;
}
